/**
 * Кому адресовано событие расписания (28.09.2026, разбор удобства админки №5, решение владельца).
 *
 * ⚠️ ЧТО БЫЛО. Форма куратора открывалась с адресом «всем», и встреча одной группы уходила в расписание каждого
 * ученика школы. Теперь куратор адресует событие только своим группам — так же проверяет и сервер calendar
 * (отказы `curator_group_only`, `not_your_group`, `audience_required`). У администратора всё как было.
 */
export type EventAudience = 'all' | 'marathon' | 'group' | 'tariff';

/**
 * Какие адреса разрешены роли. «Тариф» в приложении из магазина вырезает сама страница веткой сборки
 * (`IS_APP_BUILD ? [] : …`, сторож `storeAbsent.test.ts`) — здесь только правило роли.
 */
export function audienceOptions(role: string | undefined): EventAudience[] {
  if (role === 'curator') return ['group'];
  return ['all', 'marathon', 'group', 'tariff'];
}

/** Адрес формы при открытии: у куратора всегда «группа», у прочих — прежний адрес события или «всем». */
export function initialAudience(role: string | undefined, existing: EventAudience | undefined): EventAudience {
  if (role === 'curator') return 'group';
  return existing ?? 'all';
}

/**
 * Группа, которая уйдёт с событием: выбранная, если она среди своих; иначе — первая своя (по умолчанию куратору не
 * нужно ничего выбирать, если группа одна). Пусто — групп нет.
 */
export function effectiveGroupId(picked: string | undefined, groupIds: readonly string[]): string {
  if (picked && groupIds.includes(picked)) return picked;
  return groupIds[0] ?? '';
}

/** Можно ли сохранить: название, время и адрес, который сервер примет. */
export function canSaveEvent(f: {
  title: string;
  start_at: string;
  audience_type: EventAudience;
  marathon_id?: string;
  group_id?: string;
}): boolean {
  if (!f.title.trim() || !f.start_at) return false;
  if (f.audience_type === 'marathon') return !!f.marathon_id;
  if (f.audience_type === 'group') return !!f.group_id;
  return true;
}

/** Отказ сервера по адресу — ключ перевода; прочие отказы — общим разбором (null). */
export function audienceRefusalKey(code: string | undefined): string | null {
  switch (code) {
    case 'curator_group_only':
      return 'curatorSchedule.errGroupOnly';
    case 'not_your_group':
      return 'curatorSchedule.errNotYourGroup';
    case 'audience_required':
      return 'curatorSchedule.selectGroup';
    default:
      return null;
  }
}
